import { RESET_CART_SUCCESS } from '../../../constants/cartActionNames';

function resetCartAction() {
  return {
    type: RESET_CART_SUCCESS,
    payload: true,
  };
}

export default { resetCartAction };
